import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type SocietyProfileInvoiceParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]";
import {
  type SocietyProfileInvoicePaymentBodyInput,
  type ProcessPaymentOutput,
} from "shared/api/types/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]/payment";
export const postSocietyProfileAccountingInvoicePaymentContract: BaseApiContract<
  SocietyProfileInvoiceParamsInput,
  SocietyProfileInvoicePaymentBodyInput,
  ProcessPaymentOutput
> = {
  method: HttpMethod.POST,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]/payment",
  paramsType: {} as SocietyProfileInvoiceParamsInput,
  bodyType: {} as SocietyProfileInvoicePaymentBodyInput,
  responseType: {} as ProcessPaymentOutput,
};
